import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"
import OrganizationForm from "../pages/OrgannizationForm/index"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import { IntroScreen } from "pages/Authentication/intro-screen"
import ResetPassword from "../pages/Authentication/reset-password"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import FacebookDashboard from "../pages/FacebookDashboard/index"
import HealthgradeDashboard from "../pages/HealthgradeDashboard/index"
import CustomerDashboard from "../pages/CustomerDashboard/CustomerDashboard"
import VitalDashboard from "../pages/VitalDashboard/vitalDashboard"

//Campaign
//Campaign //Overview
import CampaignOverview from "../pages/CampaignOverview/index"
import Organizations from "../pages/Organizations/index"
//Campaign //Surveys
import Surveys from "../pages/Surveys/Survey"

//Charts
import ChartsAppex from "../pages/Charts/charts-appex"
import ChartsJs from "../pages/Charts/charts-chartjs"
import ChartsKnob from "../pages/Charts/charts-knob"
import ChartsC3 from "../pages/Charts/charts-c3"
import ChartsSparkLine from "../pages/Charts/charts-sparkline"

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import Iconion from "../pages/Icons/Iconion"
import IconFontawesome from "../pages/Icons/IconFontawesome"
import IconThemify from "../pages/Icons/IconThemify"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"
import EditableTables from "../pages/Tables/EditableTables"

// Forms
import FormElements from "../pages/Forms/FormElements"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormUpload from "../pages/Forms/FormUpload"
import FormXeditable from "../pages/Forms/FormXeditable"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiBadge from "../pages/Ui/UiBadge"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiPagination from "../pages/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline"
import PagesInvoice from "../pages/Extra Pages/pages-invoice"
import PagesDirectory from "../pages/Extra Pages/pages-directory"
import PagesBlank from "../pages/Extra Pages/pages-blank"
import Pages404 from "../pages/Extra Pages/pages-404"
import Pages500 from "../pages/Extra Pages/pages-500"
import UiUtilities from "pages/Ui/UiUtilities"
import UiColors from "pages/Ui/UiColors"
import UiOffcanvas from "pages/Ui/UiOffcanvas"
import Chat from "pages/Chat/Chat"
import Kanban from "pages/Kanban"

import CreateUserPage from "pages/CreateUserPage/index"
import SurveyForm from "pages/SurveyForm/index"
import IntegrationsPage from "pages/IntegrationsPage/index"
import ActivitiesPage from "pages/Activities/index"
import HistoryPage from "pages/History/index"
import YelpDashboard from "pages/YelpDashboard/index"
import GoogleReviewsDashboard from "pages/GoogleReviewsDashboard/index"
import InstagramDashboard from "pages/InstagramDashboard/index"
import AnalyticsDashboard from "pages/AnalyticsDashboard/index"
import Faqs from "pages/FAQs"
import ContactUs from "pages/ContactUs"
import CreateAudienceDashboard from "pages/CreateAudience/CreateAudience"
import CreateCampaign from "pages/CreateCampaign/CreateCampaign"
import SocialCampaignOverview from "pages/SocialCampaignOverview"
import CreateSocialCampaign from "pages/CreateSocialCampaign/CreateSocialCampaign"
import SocialCampaignDetails from "pages/SocialCampaignDetails/SocialCampaignDetails"
import CreateSurvey from "pages/CreateSurvey/CreateSurvey"
import CampaignDetails from "pages/CampaignDetails/CampaignDetails"
import CreatePost from "pages/FacebookDashboard/CreatePost"
import CreatePostInstagram from "pages/InstagramDashboard/CreatePost"
import { Doctors } from "pages/Doctors/Index"
import DoctorAnalysis from "pages/DoctorAnalysis"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboard/facebook", component: <FacebookDashboard /> },
  { path: "/dashboard/facebook/create-post", component: <CreatePost /> },
  { path: "/dashboard/instagram", component: <InstagramDashboard /> },
  {
    path: "/dashboard/instagram/create-post",
    component: <CreatePostInstagram />,
  },
  { path: "/dashboard/healthgrade", component: <HealthgradeDashboard /> },
  { path: "/dashboard/yelp", component: <YelpDashboard /> },
  { path: "/dashboard/google-reviews", component: <GoogleReviewsDashboard /> },
  { path: "/dashboard/google-analytics", component: <AnalyticsDashboard /> },
  { path: "/dashboard/customers", component: <CustomerDashboard /> },
  { path: "/dashboard/vitals", component: <VitalDashboard /> },
  { path: "/dashboard/entities", component: <Doctors /> },
  { path: "/dashboard/entities/analysis/:id", component: <DoctorAnalysis /> },

  // // campaign overview
  { path: "/dashboard/campaign-overview", component: <CampaignOverview /> },
  { path: "/dashboard/campaign", component: <Surveys /> },
  { path: "/dashboard/create-campaign", component: <CreateCampaign /> },
  { path: "/dashboard/campaign-details/:id", component: <CampaignDetails /> },
  {
    path: "/dashboard/social-campaigns",
    component: <SocialCampaignOverview />,
  },
  {
    path: "/dashboard/social-campaigns/create",
    component: <CreateSocialCampaign />,
  },
  {
    path: "/dashboard/social-campaigns/:id",
    component: <SocialCampaignDetails />,
  },
  { path: "/dashboard/create-survey", component: <CreateSurvey /> },
  { path: "/dashboard/integrations", component: <IntegrationsPage /> },
  { path: "/dashboard/activities", component: <ActivitiesPage /> },
  { path: "/dashboard/history", component: <HistoryPage /> },
  { path: "/faqs", component: <Faqs /> },
  { path: "/contact-us", component: <ContactUs /> },

  // // Audience
  {
    path: "/dashboard/create-audience",
    component: <CreateAudienceDashboard />,
  },
  //Organization
  { path: "/dashboard/office", component: <Organizations /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  { path: "/chat", component: <Chat /> },
  { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/dashboard/profile", component: <UserProfile /> },
  { path: "/user/create", component: <CreateUserPage /> },
  { path: "/user/update/:id", component: <CreateUserPage /> },
  { path: "/organization/:id", component: <OrganizationForm /> },

  // //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  { path: "/apex-charts", component: <ChartsAppex /> },
  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/charts-c3", component: <ChartsC3 /> },
  { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-ion", component: <Iconion /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-themify", component: <IconThemify /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },
  { path: "/tables-editable", component: <EditableTables /> },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-xeditable", component: <FormXeditable /> },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-blank", component: <PagesBlank /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/intro", component: <IntroScreen /> },
  { path: "/reset-password", component: <ResetPassword /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  {
    path: "/survey/submitResponse/:campaignId/:organizationId/:distributionId/:surveyId/:customerId",
    component: <SurveyForm />,
  },
]

export { userRoutes, authRoutes }
